var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#150029}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.5,49.2V26.7c0,0,2.5,4.2,11.7,4.5c0.5,0,0.9-0.4,0.9-0.9V24c0-0.5-0.4-0.8-0.9-0.9 c-7.1-0.4-10.5-5.9-10.8-10.9c0-0.5-0.4-0.8-0.9-0.8h-7.2c-0.5,0-0.9,0.4-0.9,0.9V48c0,3.9-3,7.3-6.8,7.4c-4.4,0.2-8-3.6-7.5-8.1 c0.4-3.2,2.9-5.8,6.1-6.2c0.6-0.1,1.2-0.1,1.8,0c0.5,0.1,1-0.3,1-0.9l0-6.4c0-0.5-0.3-0.8-0.8-0.9c-0.9-0.1-1.8,0-2.8,0.1 c-7,0.8-12.6,6.5-13.4,13.4c-1,9.2,6.2,17,15.2,17c8.4,0,15.3-6.8,15.3-15.3",
    className: "st0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.733a0b6d5373c3ada7e89f8128d1717b.svg";
export { ForwardRef as ReactComponent };